import { render } from "./PlanillaFormPopup.vue?vue&type=template&id=0fee782d&scoped=true"
import script from "./PlanillaFormPopup.vue?vue&type=script&lang=js"
export * from "./PlanillaFormPopup.vue?vue&type=script&lang=js"

import "./PlanillaFormPopup.vue?vue&type=style&index=0&id=0fee782d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fee782d"]])

export default __exports__